import { Alert } from '@treezor/design-system';

import { useAlert } from './useAlert';

export function OfflineAlert() {
  const { t, handleAlertClose, alertClasses } = useAlert('offlineWarning');

  return (
    <Alert
      icon="wifi_off"
      title={t('pages.cores.errors.isOfflineFirstPart')}
      description={t('pages.cores.errors.isOfflineSecondPart')}
      isClosable
      variant="secondary"
      type="danger"
      onClose={handleAlertClose}
      className={alertClasses}
    />
  );
}
